import { featureAccesses } from './featureAccesses';
import globals from '../../../globals/communityGlobals';

const locale = globals.getArea('header');

export const menuItems = [
  {
    id: 'dashboard-header-navlink',
    text: locale.getMsg('dashboard'),
    url: '/Dashboard',
    featureAccess: featureAccesses.dashboard,
    children: [],
  },
  {
    id: 'dailyplanning-header-navlink',
    text: locale.getMsg('dailyPlanning'),
    url: '/DailyPlanning',
    featureAccess: featureAccesses.dailyPlanning,
    children: [],
  },
  {
    id: 'planning-header-navlink',
    text: 'Planning',
    url: '/Planner',
    featureAccess: featureAccesses.planning,
    children: [
      {
        id: 'treatment-view-header-navlink',
        text: 'Treatment View',
        url: '/Planner/TreatmentView',
        featureAccess: featureAccesses.planning,
      },
      {
        id: 'clinician-view-header-navlink',
        text: 'Clinician View',
        url: '/Planner/ClinicianView',
        featureAccess: featureAccesses.planning,
      },
      {
        id: 'map-view-header-navlink',
        text: 'Map View',
        url: '/Planner/mapView',
        featureAccess: featureAccesses.planning,
      },
      {
        id: 'clinician-groups-header-navlink',
        text: 'Clinician Groups',
        url: '/Planner/ClinicianGroups',
        featureAccess: featureAccesses.planning,
      },
    ],
  },
  {
    id: 'requestlogs-header-navlink',
    text: 'Request Logs',
    url: '/RequestLogs',
    featureAccess: featureAccesses.isInIntegrationMode,
    children: [],
  },
  {
    id: 'visitactuals-header-navlink',
    text: locale.getMsg('visitActuals'),
    url: '/VisitActuals',
    featureAccess: featureAccesses.visitActuals,
    children: [],
  },
  {
    id: 'reports-header-navlink',
    text: locale.getMsg('reports'),
    url: '/Reports',
    featureAccess: featureAccesses.reports,
    children: [],
  },
  {
    id: 'patients-header-navlink',
    text: locale.getMsg('patients'),
    url: '/Patients',
    featureAccess: featureAccesses.patients,
    children: [
      {
        id: 'patientsSearch-header-navlink',
        text: 'Patients Search',
        url: '/Patients/Search',
        featureAccess: featureAccesses.patients,
      },
      {
        id: 'patientsAudit-header-navlink',
        text: 'Patients Audit',
        url: '/Patients/Audit',
        featureAccess: featureAccesses.patients,
      },
    ],
  },
  {
    id: 'nonpatientactivities-header-navlink',
    text: locale.getMsg('nonPatientActivities'),
    url: '/NonPatientActivities',
    featureAccess: featureAccesses.nonPatientActivities,
    children: [],
  },
  {
    id: 'admin-header-navlink',
    text: locale.getMsg('admin'),
    url: '/Admin',
    featureAccess: featureAccesses.admin,
    children: [
      {
        id: 'activityTypes-header-navlink',
        text: 'Activity Types',
        url: '/Admin/ActivityTypes',
        featureAccess: featureAccesses.admin,
      },
      {
        id: 'activities-header-navlink',
        text: 'Activities',
        url: '/Admin/Activities',
        featureAccess: featureAccesses.admin,
      },
      {
        id: 'nonPatientActivityTypes-header-navlink',
        text: 'Non-Patient Activity Types',
        url: '/Admin/NonPatientActivityTypes',
        featureAccess: featureAccesses.admin,
      },
      {
        id: 'configureTimeSlots-header-navlink',
        text: 'Configure Time Slots',
        url: '/Admin/ConfigureTimeSlots',
        featureAccess: featureAccesses.admin,
      },
      {
        id: 'configureClinician-header-navlink',
        text: 'Configure Clinician',
        url: '/Admin/ConfigureClinician',
        featureAccess: featureAccesses.admin,
      },
      {
        id: 'mileageCap-header-navlink',
        text: 'Mileage Cap',
        url: '/Admin/MileageCap',
        featureAccess: featureAccesses.admin,
      },
      {
        id: 'cancellationReasons-header-navlink',
        text: 'Reasons',
        url: '/Admin/Reasons',
        featureAccess: featureAccesses.admin,
      },
      {
        id: 'referralConfig-header-navlink',
        text: 'Configure Referral',
        url: '/Admin/ReferralConfig',
        featureAccess: featureAccesses.admin,
      },
      {
        id: 'cancelling-party-header-navlink',
        text: 'Cancelling Parties',
        url: '/Admin/CancellingParties',
        featureAccess: featureAccesses.admin,
      },
      {
        id: 'external-provider-navlink',
        text: 'External Provider',
        url: '/Admin/ExternalProvider',
        featureAccess: featureAccesses.integration,
      },
      {
        id: 'audit-header-navlink',
        text: 'Audit',
        url: '/Admin/Audit',
        featureAccess: featureAccesses.admin,
      },
    ],
  },
];
